import React from "react"

import styles from "./SubBanner.module.css";

function SubBanner({ title, firstText, lastText }) {
	return (
		<div className={styles.subBannerWrap}>
			<div className={styles.subText}>
				<div>
					<h2>{title}</h2>
					<p>
						<span> {firstText} </span>
						<span> {lastText} </span>
					</p>
				</div>
			</div>
		</div>
	)
}

export default SubBanner
